import { FormattedMessage } from 'react-intl';

export const TimeOutsideDuraionTitle = () => (
  <span data-testid="time-outside-duration-vp-title">
    <FormattedMessage id="vp.timeOutsideDuration.title" />
  </span>
);